import filter from 'leo-profanity';

// Initialize with default English dictionary
filter.loadDictionary('en');

// Add music-community-specific terms that should be allowed
// (common music slang that might trigger false positives)
filter.remove(['damn', 'hell', 'crap', 'suck', 'sucks', 'butt', 'sexy']);

/**
 * Check if text contains profanity.
 */
export function containsProfanity(text: string): boolean {
  return filter.check(text);
}

/**
 * Replace profane words with asterisks.
 * Messages still send - just with filtered content.
 */
export function filterProfanity(text: string): string {
  return filter.clean(text);
}
